module.exports = __webpack_public_path__ + "img/image4.b0a3c1c5.png";